import { IconPrimaryCheckWhite, ImgProjectShowcaseTabsTechStackAiCustom, ImgProjectShowcaseTabsTechStackCrms, ImgProjectShowcaseTabsTechStackMobileApps, ImgProjectShowcaseTabsTechStackWebsite } from "@/lib/images";
import { StaticImageData } from "next/image";

export interface ITabSectionListItem {
    icon_src: StaticImageData;
    icon_alt: string;
    text: string;

}

export interface IProjectShowcaseTabs {
    id: string;
    title: string;
    heading: string;
    list_item: ITabSectionListItem[];
    buttonLabel: string;
    buttonLink?: string;
    image: {
        src: StaticImageData;
        alt: string;
        width?: number;
        height?: number;
    };
}

export const Project_Showcase_Tabs_Content: IProjectShowcaseTabs[] = [
    {
        id: "mobile-apps",
        title: "Mobile Apps",
        heading: "Smart Mobile Apps, Backed by Intelligent Technology",
        list_item: [
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "Every screen is thoughtfully designed for clarity, usability, and responsiveness.",
            },
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "Built using Flutter or React Native, our apps work flawlessly on both Android and iOS — with native performance and feel.",
            },
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "Modular architecture and clean codebases ensure easy updates and long-term maintainability.",
            },
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "From real-time data to AI features, we integrate powerful tools that bring real value to your users.",
            },
        ],
        buttonLabel: "Learn more",
        image: {
            src: ImgProjectShowcaseTabsTechStackMobileApps,
            alt: "Mobile app mockups showing various app interfaces",
            width: 694,
            height: 520,

        },
        buttonLink: "/mobile-app-development-services"
    },
    {
        id: "websites",
        title: "Websites",
        heading: "Web Solutions Built to Grow Your Business",
        list_item: [
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "Every interface is crafted for clarity, performance, and responsiveness across all screen sizes.",
            },
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "Built using modern frameworks like React, Next.js — delivering lightning-fast experiences and SEO-friendly architecture.",
            },
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "Rapid development and simplifies long-term maintenance for websites.",
            },
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "From API integrations to real-time features, we embed the right tools to create seamless, user-first digital experiences.",
            },
        ],
        buttonLabel: "Learn more",
        image: {
            src: ImgProjectShowcaseTabsTechStackWebsite,
            alt: "Img Project Showcase Tabs Tech Stack Website",
            width: 649,
            height: 487,

        },
        buttonLink: "/web-development-services"
    },
    {
        id: "crms",
        title: "CRMS",
        heading: "Custom CRMs built for your Business needs",
        list_item: [
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "CRMs are designed to meet the unique requirements of a business, ensuring better alignment with processes & goals.",
            },
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "Manage and track customer interactions seamlessly to improve communication.",
            },
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "Our CRMs scale with your business, handling growing data and team needs.",
            },
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "Integrate your CRM with other business tools for smooth workflows.S",
            },
        ],
        buttonLabel: "Learn more",
        image: {
            src: ImgProjectShowcaseTabsTechStackCrms,
            alt: "Mobile app mockups showing various app interfaces",
            width: 779,
            height: 585,

        }
    },
    {
        id: "ai-custom",
        title: "AI & Custom Integrations",
        heading: "Integrations with AI & Automated Systems like never before",
        list_item: [
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "We build AI-driven systems that handle repetitive tasks so your team can focus on growth.",
            },
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "Built using modern frameworks like React, Next.js — delivering lightning-fast experiences and SEO-friendly architecture.",
            },
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "Deliver tailored content, suggestions, and support with intelligent algorithms.",
            },
            {
                icon_src: IconPrimaryCheckWhite,
                icon_alt: "Icon Primary Check White",
                text: "Automated systems ensure consistency and accuracy across your workflows.",
            },
        ],
        buttonLabel: "Learn more",
        image: {
            src: ImgProjectShowcaseTabsTechStackAiCustom,
            alt: "Img Project Showcase Tabs Tech Stack Website",
            width: 649,
            height: 487,

        }
    },
]